module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0019-73b3a18102323f21bb8e940fd10bf9e3.jpg";